import {assertDefined} from "@prosay/common"
import {DataProxy} from "apollo-cache"
import {defaultDataIdFromObject} from "apollo-cache-inmemory"
import {
    ConversationTopicInfoFragment,
    ConversationTopicInfoFragmentDoc,
    useAcceptCaseMutation,
} from "../graphql"
import {HookOptimisticResponseSync} from "./types"

const emptyTopic: Omit<ConversationTopicInfoFragment, "id"> = {
    __typename: "ConversationTopic",
    category: {
        __typename: "ConversationTopicCategory",
        id: "",
        name: "",
    },
    name: "",
}

const getTopicInformation = (cache: DataProxy, id: string) =>
    cache.readFragment<ConversationTopicInfoFragment>({
        fragment: ConversationTopicInfoFragmentDoc,
        fragmentName: "ConversationTopicInfo",
        id: assertDefined(
            defaultDataIdFromObject({__typename: "ConversationTopic", id}),
            `Could not data id of ConversationTopic with id ${id}`,
        ),
    })

export const createAcceptCaseResponse = (
    cache: DataProxy,
    question: string,
    title: string,
    topicId: string,
): HookOptimisticResponseSync<typeof useAcceptCaseMutation> => ({id}) => {
    const now = new Date().toISOString()
    const topic = getTopicInformation(cache, topicId) ?? emptyTopic

    return {
        __typename: "Mutation",
        acceptCase: {
            __typename: "Case",
            createdAt: now,
            id,
            question,
            title,
            topic: {
                id: topicId,
                ...topic,
            },
        },
    }
}
